import styled from "styled-components";
import {COLORS} from "shared/consts";

export const ArchivedWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    
    h3 {
        color: ${COLORS.FG.DEFAULT};
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        margin-bottom: 16px;
    }
`

